export interface PositionStyle {
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}

export interface Position {
  defaultStyle: PositionStyle;
  breakpoints?: {
    maxWidth: string;
    style: PositionStyle;
  }[];
}

function makeBlock({ left, right, top, bottom }: PositionStyle) {
  const block = [];
  if (left) block.push(`left: ${left} !important;`);
  if (right) block.push(`right: ${right} !important;`);
  if (top) block.push(`top: ${top} !important;`);
  if (bottom) block.push(`bottom: ${bottom} !important;`);

  return block.join("\n\t");
}

export function makeFreshDeskWidgetPositionStyles(position: Position) {
  const breakpointStyles = position.breakpoints
    ?.map(
      ({ maxWidth, style }) => `
@media (max-width: ${maxWidth}) {
  #fc_frame {
    ${makeBlock(style)}
  }
}`,
    )
    .join("\n");

  return `
#fc_frame {
  ${makeBlock(position.defaultStyle)}
  z-index: 100;
}
${breakpointStyles || ""}
    `;
}

export function makeDefaultWidgetPositionStyles(position: Position) {
  const breakpoints: Record<string, PositionStyle> = {};

  position.breakpoints?.forEach(({ maxWidth, style }) => {
    breakpoints[`@media (max-width:${maxWidth})`] = style;
  });

  return {
    ...position.defaultStyle,
    ...breakpoints,
  };
}
